<template>
    

    <div :style="`height: ${mapHeight}px; width: 100%`">
      
        <l-map class="" v-if="showMap" :zoom="mapSettings.zoom" :center="center" :options="mapOptions" style="height: 100%">
          <l-tile-layer :url="url" :attribution="attribution"/>
          <l-marker v-for="(marker, index) in markers" :key="index" :lat-lng="marker.coords" :icon="createIcon(marker)">
            <l-popup class="">
              <div class="fw-bold fs-5">
                Device Details
              </div>
              <div  style="overflow-y: scroll;">
                <div class="input-group flex-nowrap border-top border-light-grey" v-for="(pv, pi) in marker.providers" :key="pi">
                  <div class="" style="width:90%">
                    <div style="width:100%; font-size:11px;">
                        {{pv.cloud}}
                    </div>
                    <div style="width:100%; font-size:11px;">
                        {{pv.site}}
                    </div>
                    <div style="width:100%; font-size:11px;">
                        {{pv.ip}}
                    </div>
                    <div style="width:100%; font-size:11px;">
                        {{pv.mac}}
                    </div>
                  </div>
                  <div class="btn mt-1" style="align-items: center; font-size: 23px;">
                    <i class="fa-solid" :class="{'fa-circle-check text-success': pv.status === 'up', 'fa-circle-xmark text-danger': pv.status == 'down'}"></i>
                  </div>
                  
                </div>
              </div>
            </l-popup>
          </l-marker>  


        </l-map>

    </div>


</template>

<script>
import { latLng, icon, Path } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LTooltip} from "vue2-leaflet";

// My Icons

export default {
  name: "SiteMap",
  props: {
    mapHeight: String,
    mapSettings: Object,
    icons: Object,
    markers: Array,
    mapkey: String
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip
  },
  data() {
    return {
        showTypeControls: false,
        mapTile: 'terrain',
        //url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg',
        url: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        mapOptions: {
            zoomSnap: 0.25
        },
        showMap: true,
        tiles: {
            terrain: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png',
            dark: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            toner: 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner/{z}/{x}/{y}.png',
            general: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            watercolor: 'https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg',
        }
    };
  },
  methods: {
    setMapTile(mapTile){
      this.mapTile = mapTile
      this.url = this.tiles[this.mapTile] + '?api_key=' + String(this.mapkey)
    },
    createIcon(iconData){
      return icon({
          iconUrl: this.icons[iconData.icon].path,
          iconSize: this.icons[iconData.icon].size,
          iconAnchor: this.icons[iconData.icon].anchor
      })
    }
  },
  computed: {
    center(){
      return latLng(this.mapSettings.centerLat, this.mapSettings.centerLon)
    }
  },
  mounted(){
    this.setMapTile(this.mapSettings.theme)
  }
};
</script>
